// Workstation API client helpers

export async function fetchTasks() {
  const res = await fetch('/api/membros/tasks')
  if (!res.ok) throw new Error('Failed to fetch tasks')
  const data = await res.json()
  return data.tasks
}

export async function moveTask(taskId: string, status: string, position: number, csScore?: number) {
  const res = await fetch(`/api/membros/tasks/${taskId}/move`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ status, position, cs_score: csScore }),
  })
  if (!res.ok) throw new Error('Failed to move task')
  return res.json()
}

export async function toggleSubtask(taskId: string, subtaskIndex: number, checked: boolean) {
  const res = await fetch(`/api/membros/tasks/${taskId}/subtask`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ subtask_index: subtaskIndex, checked }),
  })
  if (!res.ok) throw new Error('Failed to toggle subtask')
  return res.json()
}

export async function fetchLayers() {
  const res = await fetch('/api/membros/layers')
  if (!res.ok) throw new Error('Failed to fetch layers')
  const data = await res.json()
  return data.layers
}
